module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('industry-single', {
    scopedSlots: _vm._u([{
      key: "hero",
      fn: function() {
        return [_c('hero-full', {
          attrs: {
            "imageName": "industries/excavation-banner.jpg",
            "altText": "Man next to the excavator"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h1', [_vm._v("Excavator Financing")]), _vm._v(" "), _c('p', [_vm._v("Business Loans for Excavation Equipment")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "form-section",
      fn: function() {
        return [_c('FormSection', {
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" Empowering Excavator Operators\n          everyday.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Excavation is the lifeblood of a construction site. Whether you’re\n          working on a house project, road construction, or larger job, you\n          need a trustworthy Excavator. Crews count on their excavators to\n          dig, break, and lift all types of material at a moments notice.\n          Excavators usually last between 7,000 and 10,000 hours, so it’s\n          important to have immediate financing to find a quick replacement.\n          Read on and see how American Credit helps business owners purchase\n          Excavation equipment with quick funding.\n        ")])]
            },
            proxy: true
          }, {
            key: "logos",
            fn: function() {
              return [_c('div', {
                staticClass: "row"
              }, [_c('div', {
                staticClass: "col-12 col-md-5 order-md-2 d-flex"
              }, [_c('div', {
                staticClass: "row align-items-center logos-brands"
              }, [_c('div', {
                staticClass: "col-6 col-md-12"
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/nefa-logo.png",
                  "alt": "NEFA logo"
                }
              })]), _vm._v(" "), _c('div', {
                staticClass: "col-6 col-md-12"
              }, [_c('a', {
                attrs: {
                  "href": "https://www.bbb.org/us/ca/palo-alto/profile/financial-services/american-credit%C2%AE-inc-1216-1079741",
                  "target": "_blank"
                }
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/bbba-logo.png",
                  "alt": "BBBA logo"
                }
              })])])])]), _vm._v(" "), _c('div', {
                staticClass: "col-12 col-md-7"
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/google-review.png",
                  "alt": "Google Review"
                }
              })])])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "first-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "left",
            "imageName": "industries/excavation-equipment-loans.jpg",
            "altText": "Excavation machine",
            "backgroundPrimary": "#00234D",
            "backgroundSecondary": "#F6F9FE"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Instant Excavation Equipment Loans")]), _vm._v(" "), _c('p', [_vm._v("\n          Use your Excavation Equipment Loan to purchase any needed equipment,\n          such as crawler excavators, dragline excavators, suction excavators,\n          skid steer excavators, track frames, hydraulic cylinders, buckets &\n          more! When you talk with our lending experts, you will be speaking\n          to lending experts who are extremely knowledgeable about the\n          excavation industry’s exact needs.\n          "), _c('br'), _c('br'), _vm._v("\n          American Credit understands the difficulties the excavation industry\n          faces. We work with you to understand your unique equipment needs,\n          and then secure quick funding so you can get back to work.\n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "second-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "right",
            "imageName": "industries/excavation-working-capital.jpg",
            "altText": "Excavation Worker"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Working Capital Solutions for Excavator Operators")]), _vm._v(" "), _c('p', [_vm._v("\n          Received a sudden lucrative project, but can’t wait for delayed\n          financing? Have an upcoming employee payroll deadline? American\n          Credit can fix any short-term or long-term financial difficulties\n          you are facing. Call us to find out what working capital options are\n          available to fix any situation your excavation business faces.\n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "third-row",
      fn: function() {
        return [_c('IconsGrid', {
          attrs: {
            "gridElements": _vm.gridItems
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Geared to Your Needs and Your Business")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fourth-row",
      fn: function() {
        return [_c('TablesSection', {
          attrs: {
            "tables": _vm.tableItems,
            "ctaButtonTitle": "Apply For Excavator Financing"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Excavator Financing Requirements")]
            },
            proxy: true
          }, {
            key: "text",
            fn: function() {
              return [_vm._v("Minimum loan requirements to expedite approval & secure quick\n        funding.")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fifth-row",
      fn: function() {
        return [_c('RowSection', {
          staticClass: "lei-section",
          attrs: {
            "img-side": "right",
            "imageName": "industries/Lei-li-formal.jpeg",
            "altText": "photo Dr. Lei Li, CEO of American Credit, Inc., in blue suit smiling"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" The Difference You Can Trust")]), _vm._v(" "), _c('p', [_vm._v("\n          Your business is not JUST a business. It’s YOURS. It’s your\n          livelihood. It’s your passion. American Credit completely\n          understands this. We help business owners just like you everyday, by\n          taking a wholistic approach to business financing.\n          "), _c('strong', [_vm._v("Dr. Lei Li, PhD, CFA, & CEO of American Credit")]), _vm._v(", is\n          an Economist who uses his 20+ years of industry experience to help\n          business owners achieve their American Dream:\n          "), _c('strong', [_vm._v("successful business ownership")]), _vm._v(". "), _c('br'), _c('br'), _vm._v("\n          Whatever financial situation you’re in, American Credit has your\n          back. Apply for your business loan today!\n        ")])]
            },
            proxy: true
          }, {
            key: "button-contact",
            fn: function() {
              return [_c('contact-info', {
                staticClass: "d-none d-md-flex",
                attrs: {
                  "imageName": "Lei_Li.png",
                  "altText": "Lei's photo",
                  "title": "Call Lei",
                  "contactType": "Service",
                  "phoneNumber": "650-885-8055"
                }
              })]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "google-reviews",
      fn: function() {
        return [_c('div', {
          staticClass: "elfsight-app-8279c03d-9a65-4465-b949-ecb8d18697e0"
        })]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-217d38fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/industries/excavatorFinancing.vue
// module id = 1951
// module chunks = 5